import { InputGroup } from "@blueprintjs/core";
import React from "react";
import { compareTwoObjects } from "../fns/util";
import { inject, observer } from "mobx-react";
import _ from "lodash";

class AdverseEventMaster extends React.Component {
  state = {
    changed: false,
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }
  anaesthesiaTypes = [
    "Local Anaesthesia",
    "General Anaesthesia",
    "Topical Anaesthesia",
    "Lid Block",
  ];
  render() {
    return (
      <>
        <td>
          <InputGroup
            fill
            value={this.state.entityName}
            onChange={(event) => {
              this.setState(
                { entityName: event.target.value, changed: true },
                () =>
                  this.props.onUpdate(
                    compareTwoObjects(this.state, this.props.data)
                  )
              );
            }}
          />
        </td>
        <td>
          <InputGroup
            fill
            value={this.state.description}
            onChange={(event) => {
              this.setState(
                { description: event.target.value, changed: true },
                () =>
                  this.props.onUpdate(
                    compareTwoObjects(this.state, this.props.data)
                  )
              );
            }}
          />
        </td>
      </>
    );
  }
}

export default inject("authStore")(observer(AdverseEventMaster));
